import {
  List,
  Datagrid,
  TextField,
  NumberField, 
  DateField,  
} from "react-admin";
import {Tabs, Tab} from "@mui/material";
import { useState } from "react";


const PaymentTabs = ({ setStatusFilter }) => {
  const [tab, setTab] = useState(0);
  const handleChange = (event, newValue) => {
    setTab(newValue);
    const status = ["", "approved", "pending", "rejected"][newValue];
    setStatusFilter(status);
  };

  return (
    <Tabs value={tab} onChange={handleChange} centered>
      <Tab label="Todos" />
      <Tab label="Aprobados" />
      <Tab label="Pendientes" />
      <Tab label="Rechazados" />
    </Tabs>
  );
};


const PaymentList = () => {
  const [statusFilter, setStatusFilter] = useState();

 return (
  <>
  <PaymentTabs setStatusFilter={setStatusFilter} />
  <List 
  resource="payments"
  filter={statusFilter?{status:statusFilter}:{}}
  perPage={25}
   >
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="status" label="Estado"/>
      <TextField source="payer_email" label="Comprador"/>
      <NumberField source="amount" label="Monto"/>
      <TextField source="course_title" label="Curso"/>
      <DateField source="createdAt" label="Fecha"/>

    </Datagrid>

  </List>
  </>
 )
};

export default PaymentList;
